import { getApiBaseUrl } from '../shared/api/runtimeConfig'

/** Paramètre lu par le backend (core/i18n.py) pour la langue des libellés venant de la base. */
export const LANGUAGE_PARAM = 'lang'

let installed = false

function requestUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.href
  return input.url
}

/**
 * Ajoute `?lang=` aux appels vers l'API quand la langue n'est pas la langue source.
 * Un paramètre plutôt qu'un en-tête : pas de requête CORS préalable, et les caches HTTP
 * distinguent les langues par l'URL. En langue source, les requêtes restent inchangées.
 */
export function installApiLanguageParam(getLanguage: () => string, sourceLanguage: string) {
  if (installed || typeof window === 'undefined' || typeof window.fetch !== 'function') return
  installed = true
  const apiBase = getApiBaseUrl()
  const originalFetch = window.fetch.bind(window)

  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const lang = getLanguage()
    const url = requestUrl(input)
    if (lang === sourceLanguage || !(url.startsWith(apiBase) || url.startsWith('/api/'))) {
      return originalFetch(input, init)
    }
    const target = new URL(url, window.location.href)
    if (target.searchParams.has(LANGUAGE_PARAM)) return originalFetch(input, init)
    target.searchParams.set(LANGUAGE_PARAM, lang)
    if (input instanceof Request) return originalFetch(new Request(target.href, input), init)
    return originalFetch(target.href, init)
  }
}
